"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nestedPropExists = void 0;

var nestedPropExists = function nestedPropExists(obj, level1) {
  if (obj === undefined) return false;

  for (var _len = arguments.length, deeperLevels = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    deeperLevels[_key - 2] = arguments[_key];
  }

  if (deeperLevels.length === 0 && Object.prototype.hasOwnProperty.call(obj, level1)) return true;
  return nestedPropExists.apply(void 0, [obj[level1]].concat(deeperLevels));
};

exports.nestedPropExists = nestedPropExists;